/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './ProjectSummary.scss';
var renderWorkLocation = function renderWorkLocation(workLocation, shortOfficeLocation) {
  switch (workLocation.toLowerCase()) {
    case 'office':
      return "In Office at ".concat(shortOfficeLocation);
    case 'remote':
      return 'Remote';
    case 'hybrid':
      return "Hybrid, in office at ".concat(shortOfficeLocation);
    case 'not sure':
      return 'Workplace Type - Unsure';
    case "i don't know yet":
      return 'Workplace Type - Unsure';
    default:
      return 'Work preference';
  }
};
var renderHourlyRate = function renderHourlyRate(minHourlyRate, maxHourlyRate) {
  return /*#__PURE__*/React.createElement("div", {
    className: "commitment hourly-rate"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-dollar-sign"
  }), "".concat(minHourlyRate), minHourlyRate && maxHourlyRate && ' - ', maxHourlyRate ? "".concat(maxHourlyRate, "/hour") : '/hour');
};
var renderTravel = function renderTravel(travelTime, daysOfTravel, travelLocations, location) {
  if (daysOfTravel && travelLocations) {
    return /*#__PURE__*/React.createElement("div", {
      className: "commitment travel"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-plane"
    }), "Travel to", ' ', travelLocations, ' ', daysOfTravel, ' ', "days/month");
  }
  if (travelLocations) {
    return /*#__PURE__*/React.createElement("div", {
      className: "commitment travel"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-plane"
    }), "Travel -", ' ', travelLocations);
  }
  if (daysOfTravel) {
    return /*#__PURE__*/React.createElement("div", {
      className: "commitment travel"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-plane"
    }), daysOfTravel, ' ', "days/month");
  }
  if (location === 'default' && travelTime) {
    return /*#__PURE__*/React.createElement("div", {
      className: "commitment travel"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-plane"
    }), travelTime === 'not sure' ? 'Travel Requirements - Not confirmed' : 'Travel Requirements -  Not Applicable');
  }
  return null;
};
var renderTags = function renderTags(tags, customClasses) {
  return tags.map(function (t) {
    return /*#__PURE__*/React.createElement("span", {
      key: t,
      className: "badge small ".concat(customClasses, " normal-font")
    }, t);
  });
};
function ProjectSummary(_ref) {
  var name = _ref.name,
    workCommitment = _ref.workCommitment,
    areaOfExpertises = _ref.areaOfExpertises,
    tags = _ref.tags,
    _ref$jobTitles = _ref.jobTitles,
    jobTitles = _ref$jobTitles === void 0 ? null : _ref$jobTitles,
    description = _ref.description,
    responsibilities = _ref.responsibilities,
    duration = _ref.duration,
    durationText = _ref.durationText,
    workLocation = _ref.workLocation,
    shortOfficeLocation = _ref.shortOfficeLocation,
    minHourlyRate = _ref.minHourlyRate,
    maxHourlyRate = _ref.maxHourlyRate,
    startDate = _ref.startDate,
    daysOfTravel = _ref.daysOfTravel,
    _ref$travelTime = _ref.travelTime,
    travelTime = _ref$travelTime === void 0 ? null : _ref$travelTime,
    travelLocations = _ref.travelLocations,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? 'default' : _ref$location,
    _ref$ideal_candidate_ = _ref.ideal_candidate_list,
    idealCandidateList = _ref$ideal_candidate_ === void 0 ? [] : _ref$ideal_candidate_,
    workCommitmentText = _ref.workCommitmentText;
  return /*#__PURE__*/React.createElement("div", {
    className: "project-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-header"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "demibold project-name mt-2"
  }, name || 'Project Name'), /*#__PURE__*/React.createElement("div", {
    className: "body-text-1 muted-gray-text"
  }, jobTitles && "Relevant Job Titles(s): ".concat(jobTitles))), /*#__PURE__*/React.createElement("div", {
    className: "project-commitments body-text-3"
  }, shortOfficeLocation && /*#__PURE__*/React.createElement("div", {
    className: "commitment work-location"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas  fa-map-marker-alt"
  }), renderWorkLocation(workLocation, shortOfficeLocation)), duration && /*#__PURE__*/React.createElement("div", {
    className: "commitment work-duration"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-calendar-day"
  }), duration === 'not sure' ? 'Length of engagement - Not confirmed' : "".concat(durationText || "".concat(duration, " month"), " duration")), (minHourlyRate || maxHourlyRate) && renderHourlyRate(minHourlyRate, maxHourlyRate), workCommitment && /*#__PURE__*/React.createElement("div", {
    className: "commitment work-commitment"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-clock"
  }), workCommitment === 'not sure' ? 'Hours - Not confirmed' : workCommitmentText || "".concat(workCommitment, " hours/week")), startDate ? /*#__PURE__*/React.createElement("div", {
    className: "commitment approximate-start-date-local"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-hourglass-start"
  }), "Starting", ' ', moment(startDate) < new Date() ? 'ASAP' : moment(startDate).format('LL')) : '', !startDate && location === 'default' ? /*#__PURE__*/React.createElement("div", {
    className: "commitment approximate-start-date-local"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-hourglass-start"
  }), "Starting date - Not confirmed") : '', renderTravel(travelTime, daysOfTravel, travelLocations, location)), (areaOfExpertises.length > 0 || tags.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "tags mb-2 d-flex flex-wrap gap-2"
  }, renderTags(areaOfExpertises, 'purple-base'), renderTags(tags, '')), /*#__PURE__*/React.createElement("div", {
    className: "project-description body-text-2"
  }, description || 'Description...'), responsibilities && responsibilities.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "project-responsibilities"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "medium-weight mb-2"
  }, "Responsibilities"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
    className: "responsibility_areas dashed"
  }, responsibilities.map(function (r) {
    return /*#__PURE__*/React.createElement("li", {
      key: r
    }, r);
  })))), idealCandidateList.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "project-responsibilities"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "medium-weight mb-2"
  }, "Ideal Candidate Description"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
    className: "responsibility_areas dashed"
  }, idealCandidateList.map(function (r) {
    return /*#__PURE__*/React.createElement("li", {
      key: r
    }, r);
  })))));
}
ProjectSummary.propTypes = {
  name: PropTypes.string.isRequired,
  workCommitment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  workCommitmentText: PropTypes.string,
  jobTitles: PropTypes.string,
  description: PropTypes.string.isRequired,
  responsibilities: PropTypes.arrayOf(PropTypes.string).isRequired,
  areaOfExpertises: PropTypes.arrayOf(PropTypes.string).isRequired,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  durationText: PropTypes.string,
  workLocation: PropTypes.string.isRequired,
  shortOfficeLocation: PropTypes.string.isRequired,
  minHourlyRate: PropTypes.string,
  maxHourlyRate: PropTypes.string,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  daysOfTravel: PropTypes.string,
  travelTime: PropTypes.string,
  travelLocations: PropTypes.string,
  location: PropTypes.string,
  ideal_candidate_list: PropTypes.arrayOf(PropTypes.string)
};
export default ProjectSummary;